const React = require('react');

const {
  initFilter,
  getDefaultFilterParams
} = require('../../../../../../../dumb/IntervalFilterCustom');
const virtualOutputComponentProvider = require('../../../../../../../../utils/virtualOutputComponentProvider');
// const {apiAdminRetailersPaymentList} = require('../../../../../../../../api/admin/payment');

const {TrxTableDisplay, TrxTableItemDisplay} = require('../../../../../../../dumb/AdminHelpers/AdminTrx')

const filter$ = initFilter();

module.exports = virtualOutputComponentProvider({
  state: {
    filter: filter$,
  },
  rowHeight: 60,
  // request: apiAdminRetailersPaymentList,
  getParams: getDefaultFilterParams,
  wrapper(render, setState, self) {
    return (state, props) => {
      return (
        <TrxTableDisplay
          self={self}
          filter$={filter$}
          items={render(TrxTableItemDisplay, {...props, showCustomer: true})}
          showCustomer
        />
      );
    };
  },
});
